import { EnvironmentService } from './EnvironmentService';

export class TrackingService {
  private static serviceInstance = new TrackingService();

  public static get instance(): TrackingService {
    return this.serviceInstance;
  }

  private get apiUrl(): string {
    const env = EnvironmentService.getEnv();
    return `https://lpb-events-${env}.uk-tla.com/api/event`;
  }

  public async sendEvent(eventType: EventTypeEnum, correlationId: string, eventData: any) {
    const requestBody = {
      eventType,
      correlationId,
      eventData
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    };

    const timeoutMs = 6000;

    if (typeof AbortController !== 'undefined') {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), timeoutMs);

      try {
        const response = await fetch(this.apiUrl, {
          ...requestOptions,
          signal: controller.signal
        });

        if (!response.ok) {
          console.error(`sendEvent failed with status: ${response.status}`);
        }
      } catch (error: unknown) {
        if (error instanceof DOMException && error.name === 'AbortError') {
          console.error('sendEvent request timed out after 6 seconds');
        } else if (error instanceof Error) {
          console.error('sendEvent encountered an error:', error.message);
        } else {
          console.error('sendEvent encountered an unknown error:', error);
        }
      } finally {
        clearTimeout(timeout);
      }
    }
  }
}

export enum EventTypeEnum {
  PageLoad = 1,
  StepChange = 2,
  FormComplete = 3,
  TrimbotLoaded = 4
}
